import React from 'react';
import { useHistory } from 'react-router-dom';
import { LOCLogo } from '../../assets/images';
import { ROUTE_PATH } from '../../routes/paths';

const InvitationRevoked: React.FunctionComponent = (): JSX.Element => {
  const history = useHistory();
  const handleClose = () => {
    localStorage.clear();
    history.push(ROUTE_PATH.LOGIN);
  };
  return (
    <div>
      <div className="bg-gray-background-light flex h-screen w-full items-center justify-center">
        <div className="w-96 bg-white px-8 pb-12 pt-8">
          <div className="text-primary w-full">
            <div className="flex justify-center pt-4">
              <img src={LOCLogo} alt="kindly-logo" className="w-56" />
            </div>
            <h3 className="text-bright-blue pt-10 text-xl">Invitation Unavailable</h3>
            <h3 className="text-gray-dark pt-4 text-sm">
              Your invitation has been canceled and is no longer available.
            </h3>
            <div className="mt-8 flex justify-center">
              <button
                type="button"
                className="bg-bright-blue rounded-full px-12 py-1.5 text-white"
                onClick={handleClose}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvitationRevoked;
